import React from 'react';
import { Button } from '@mui/material';
import { styled } from 'styled-components';

export const ButtonContainer = styled.div`
  display: flex;
  gap: 4px;
  border: 2px solid blue,
  padding: 4px
`;

export const StyledDownloadButton = styled(Button)<{ bgImage: string }>`
  width: 200px;
  height: 80px;
  padding: 0;
  background-image: url(${({ bgImage }) => bgImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 16px;

  &:hover {
    opacity: 0.8;
  }
`;
